export default "__VITE_ASSET__D0GgUfs7__"